theme.testimonials = (function(){
  const numberOfSlides = 5;

  const selectors = {
    section: '[data-section-type="testimonial-slider"]',
    inner: '.testimonial-slider__inner',
    images: '.testimonial-slider__images',
    slide: '.swiper-slide'
  }

  const init = () => {
    let testimonialSliders = document.querySelectorAll(selectors.section);
    
    testimonialSliders.forEach(slider => {
      initTestimonial(`[data-section-id="${slider.dataset.sectionId}"]`);
    });
  }

  const cloneSlides = (slides, container) => {
    slides.forEach(el => {
      const cloned = el.cloneNode(true);
      container.appendChild(cloned);        
    });
  }

  const initTestimonial = (id) => {
    let slides = document.querySelectorAll(`${id} ${selectors.inner} ${selectors.slide}`);
    if(slides.length <= numberOfSlides){
      let container = document.querySelector(`${id} ${selectors.inner} .swiper-wrapper`);
      cloneSlides(slides, container);
    }

    let sliderEl = document.querySelector(`${id} ${selectors.inner}`);

    let sliderOptions = {
      loop: sliderEl.dataset.loop === 'true',
      centeredSlides: sliderEl.dataset.centered === 'true',
      speed: theme.config.durations.long,
      grabCursor: true,
      slidesPerView: parseFloat(sliderEl.dataset.columnsMobile),
      spaceBetween: 30,
      breakpoints: {
        768: {
          slidesPerView: parseFloat(sliderEl.dataset.columnsTablet),
        },
        1200: {
          slidesPerView: parseFloat(sliderEl.dataset.columnsDesktop),
        }
      }
    };

    if(sliderEl.dataset.autoplay === 'true'){
      sliderOptions.autoplay = {
        delay: parseFloat(sliderEl.dataset.autoplayDelay * 1000)
      }
    }

    if(sliderEl.dataset.arrowsEnabled === 'true'){
      sliderOptions.navigation = {
        nextEl: `${id} .swiper-button-next`,
        prevEl: `${id} .swiper-button-prev`,
      };
    }

    if(sliderEl.dataset.paginationEnabled === 'true'){
      sliderOptions.pagination = {
        el: `${id} .swiper-pagination`,
        type: sliderEl.dataset.paginationType,
        clickable: true
      };
    }

    const swiper = new Swiper(`${id} ${selectors.inner}`, sliderOptions);    
  }

  return {
    selectors,
    init
  }
})();